import * as React from "react";

var Footer = function Footer(props) {
  var polizaId = props.polizaId;
  return /*#__PURE__*/React.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/admin/polizas/".concat(polizaId, "/"),
    className: "btn btn-default btn-mini"
  }, "Ver email de despacho")), /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/admin/polizas/".concat(polizaId, "/edit"),
    className: "btn btn-default btn-mini"
  }, "Editar")), /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/admin/polizas/".concat(polizaId, "/renew"),
    className: "btn btn-primary"
  }, "Renovar")), /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/admin/polizas/".concat(polizaId),
    className: "btn btn-danger",
    "data-confirm": "Are you sure?",
    rel: "nofollow",
    "data-method": "delete"
  }, "Borrar")), /*#__PURE__*/React.createElement("div", {
    className: "col-md-1 col-md-offset-6"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-secondary",
    "data-dismiss": "modal"
  }, "Cerrar"))));
};

export default Footer;